// extracted by mini-css-extract-plugin
module.exports = {"techWrapper":"styles_techWrapper__1boAO","techWrapperOther":"styles_techWrapperOther__3jurH"};